import router from '../router'
import store from '../store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { auditLog } from 'api/common'
import { Message } from 'element-ui'
function getToken(key) {
  return sessionStorage.getItem(key);
}

function MyMessage(option) {
  Message.closeAll()
  Message(option)
}
MyMessage.success = function (option) {
  Message.closeAll()
  Message.success(option)
}
MyMessage.warning = function (option) {
  Message.closeAll()
  Message.warning(option)
}
MyMessage.error = function (option) {
  Message.closeAll()
  Message.error(option)
}
MyMessage.info = function (option) {
  Message.closeAll()
  Message.info(option)
}

router.beforeEach((to, from, next) => {
  NProgress.start(); // 开启Progress
  store.commit('setLastRoutePath', from.path)
  if (to.matched.some(record => record.meta.isStatic)) {
    if (getToken('sessionId1')) {
      if (to.name === 'login' || to.name === 'loginForA') {
        router.app.eventBus && router.app.eventBus.$emit('reset-head');
        next({ path: '/home' });
        NProgress.done()
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    if (getToken('sessionId1')) {
      if (sessionStorage.authStatus === 2 || sessionStorage.authStatus === '2') {
        if (sessionStorage.isFreeze !== '4' && sessionStorage.isFreeze !== '5') {
          next();
        } else if (sessionStorage.isFreeze === '4' && to.path !== '/personalCenter') {
          MyMessage.warning('实名认证信息审核中，请等待审核成功后再进行操作！')
          next('/personalCenter');
          NProgress.done()
        } else {
          MyMessage.warning('实名认证信息审核失败，请重新进行实名认证！')
          next('/personalCenter');
          NProgress.done()
        }
      } else {
        MyMessage.warning('请先完成实名认证，再继续其他操作！')
        next('/register?phone=' + sessionStorage.account)
        NProgress.done()
      }
    } else {
      next('/')
    }
  }
});

router.afterEach(() => {
  NProgress.done()
});



// WEBPACK FOOTER //
// ./src/utils/permission.js